import { Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountMenu from "../../../components/AccountMenu/AccountMenu";
import { BrandedAppBar, BrandedLogo } from "../../../shared/ui/AppBar";
import { NavHeader } from "../../../features/navigation";

/**
 * Props for the AuthNavHeader component.
 *
 * @property {() => void} [onMenuClick] - Optional handler for the menu button click event
 */
interface NavHeaderProps {
    onMenuClick?: () => void;
}

/**
 * AuthNavHeader
 *
 * A header bar for authenticated users, including a menu button, branded logo, and account menu.
 * Uses NavHeader and BrandedAppBar for consistent layout and branding.
 *
 * @param {NavHeaderProps} props - The props for the AuthNavHeader component.
 * @returns {JSX.Element} The rendered header bar.
 */
export const AuthNavHeader = ({ onMenuClick }: NavHeaderProps) => {
    return (
        <NavHeader>
            <BrandedAppBar>
                <IconButton
                    color="default"
                    aria-label="open drawer"
                    edge="start"
                    onClick={onMenuClick}
                    sx={{
                        mr: 2,
                        display: { xs: "block", sm: "block", md: "none" },
                        color: "#333",
                    }}
                >
                    <MenuIcon />
                </IconButton>
                <BrandedLogo />
                <Box sx={{ marginLeft: "auto" }}>
                    <AccountMenu />
                </Box>
            </BrandedAppBar>
        </NavHeader>
    );
};
